// import { Spine } from '@esotericsoftware/spine-pixi-v7'
// import * as PIXI from 'pixi.js'
// import { Spine } from 'pixi-spine';

import { gameAssets } from "./gameUI"
import gsap from 'gsap';
import { gameData } from './data';
import { delayedCalls } from './commendation';
import {  playAirPump, playBallonExp, playBallonExp1, playBallonExp2, playBallonExp3 } from './soundManager';

let delayedCall
const pumpAnimationStates = [
    'ballon_pump_state_01_idle',
    'ballon_pump_pop_1x_Loop',
    'ballon_pump_pop_1x_Out',
    'ballon_pump_state_01_to_02',
    'ballon_pump_state_02_idle',
    'ballon_pump_pop_2x_Loop',
    'ballon_pump_pop_2x_Out',
    'ballon_pump_state_02_to_03',
    'ballon_pump_state_03_idle',
    'ballon_pump_pop_3x_Loop',
    'ballon_pump_pop_3x_Out',
    'ballon_pump_state_03_to_04',
    'ballon_pump_state_04_idle',
    'ballon_pump_state_04_to_05',
    'ballon_pump_state_05_idle',
    'ballon_pump_state_05_to_06',
    'ballon_pump_state_06_idle',
    'ballon_pump_state_06_to_07',
    'ballon_pump_state_07_idle',
    'ballon_pump_state_07_to_08',
    'ballon_pump_state_08_idle',
    'ballon_pump_state_08_to_09',
    'ballon_pump_state_09_idle',
    'ballon_pump_state_09_to_pop_1x',
    'ballon_pump_state_09_to_pop_2x',
    'ballon_pump_state_09_to_pop_3x'
]

export const pumpIdleAnimation = [
    'ballon_pump_state_01_idle', //0
    'ballon_pump_state_02_idle', // 1
    'ballon_pump_state_03_idle',
    'ballon_pump_state_04_idle',
    'ballon_pump_state_05_idle',
    'ballon_pump_state_06_idle',
    'ballon_pump_state_07_idle',
    'ballon_pump_state_08_idle',
    'ballon_pump_state_09_idle', // 8
]

export const pumpTransitionAnimations = [
    'ballon_pump_state_01_to_02',
    'ballon_pump_state_02_to_03',
    'ballon_pump_state_03_to_04',
    'ballon_pump_state_04_to_05',
    'ballon_pump_state_05_to_06',
    'ballon_pump_state_06_to_07',
    'ballon_pump_state_07_to_08',
    'ballon_pump_state_08_to_09',
    'ballon_pump_state_08_to_09'
]

export const pumpMultiplierBurst = [
    'ballon_pump_state_09_to_pop_1x', // 0
    'ballon_pump_pop_1x_Loop',
    'ballon_pump_pop_1x_Out',
    'ballon_pump_state_09_to_pop_2x', // 3
    'ballon_pump_pop_2x_Loop',
    'ballon_pump_pop_2x_Out',
    'ballon_pump_state_09_to_pop_3x', // 6
    'ballon_pump_pop_3x_Loop',
    'ballon_pump_pop_3x_Out',
    'ballon_pump_state_09_to_pop_4x', // 9
    'ballon_pump_pop_4x_Loop',
    'ballon_pump_pop_4x_Out'
]

export const ballonSounds = [
    'ballonInf1', 'ballonInf2','ballonInf3','ballonInf4','ballonInf5','ballonInf6','ballonInf7' 
]

export const ballonMultiplierSounds = ['multiplier1', 'multiplier2', 'multiplier3']

const setPumpAnimation = (animationIndex, animationArray) => {
    const animation = animationArray[animationIndex]
    
    if (animation) {
        
        gameAssets.pump.state.setAnimation(0, animation, true)
        setPumpAnimationTimeScale(1)
    } else {
        // console.warn(`Animation at index ${animationIndex} not found.`)
    }
}

export const setPumpIdleAnimation = (animationIndex) => {    
    setPumpAnimation(animationIndex, pumpIdleAnimation)

    if(gameData.scratchDoneNumber < ballonSounds.length && gameData.scratchDoneNumber >= 0) playBallonExp(ballonSounds[gameData.scratchDoneNumber], true)
    else playBallonExp(ballonSounds[ballonSounds.length-1], true) 
    
}

export const setPumpTransitionAnimation = (animationIndex) => {

    setPumpAnimation(animationIndex, pumpTransitionAnimations)
    playAirPump(true)
}

const setPumpAnimationTimeScale = (scale) => gameAssets.pump.state.timeScale = scale

export const resetPump = () => {
    setPumpIdleAnimation(0)
    gameData.scratchDoneNumber = 0
}

export const setPumpMultiplierInAnimation = (index) => {

    // if(networkData.scratchResult != RESULTS.LOST){        
    //     if(index <= ballonMultiplierSounds.length && index >= 0) playBallonExp(ballonMultiplierSounds[index], true)
    //     else playBallonExp(ballonMultiplierSounds[ballonMultiplierSounds.length-1], true) 
    // }

    const animationIndex = 3 *  (index - 1)
    const animationIn = pumpMultiplierBurst[animationIndex]
    const animationLoop = pumpMultiplierBurst[animationIndex + 1]
    const animationOut = pumpMultiplierBurst[animationIndex + 2]
    
    if (animationIn && animationLoop && gameAssets?.pump?.state) {
        gameAssets.pump.state.setAnimation(0, animationIn, false)
        
       
        delayedCall = gsap.delayedCall(2, ()=>{            
         if(index == 1){
            playBallonExp1(true)
        } else if(index == 2){
             playBallonExp2(true);
        } else {
            playBallonExp3(true)
        }  
        onPumpBurstEntryAnimationComplete(animationLoop, animationOut)})
        delayedCalls.push(delayedCall)
        setPumpAnimationTimeScale(1)
        } else {
            // console.error(`PumpMultiplierBurst Animation at index ${animationIndex} or ${animationIndex + 1} or ${gameAssets?.pump?.state} not found.`)
        }
    }
    
const onPumpBurstEntryAnimationComplete = (animationLoop, animationOut) =>{
    gameAssets.pump.state.addAnimation(0, animationLoop, true, 0)

    // delayedCall = gsap.delayedCall(25, () => {
    //     gameAssets.pump.state.setAnimation(0, animationOut, false)
    // })
    // delayedCalls.push(delayedCall)

}